import React from 'react';

const LoginFooter = () => {
    return (
        <footer className="footer">
            <p>
              For any queries, Please write to us at &nbsp;
              <a href="mailto:care@ihx.in" className="text-light">
                care@ihx.in
              </a>
            </p>

            <p>©{new Date().getFullYear()}, IHX Private Limited. All Rights Reserved.</p>
        </footer>
    );
};

export default LoginFooter;
